import { useEffect, useState } from "react";
import { format, addDays } from "date-fns";

import { availabilityService } from "../services/availability";

/**
 * Shared, memoised availability lookup for the next 14 days.
 * The Dashboard's Availability-alerts widget consumes this — a single
 * outstanding request per mount serves every consumer.
 */
let cache = null;
let promise = null;

function todayIso() {
  return format(new Date(), "yyyy-MM-dd");
}

function fetchOnce() {
  if (cache) return Promise.resolve(cache);
  if (promise) return promise;
  const from = todayIso();
  const until = format(addDays(new Date(), 13), "yyyy-MM-dd");
  promise = availabilityService
    .grid(from, until)
    .then((data) => {
      cache = { from, until, data };
      promise = null;
      return cache;
    })
    .catch((e) => {
      promise = null;
      throw e;
    });
  return promise;
}

/** Reset — used by tests or when dashboard is reloaded manually. */
export function resetAvailability14dCache() {
  cache = null;
  promise = null;
}

export function useAvailability14d() {
  const [state, setState] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    let mounted = true;
    fetchOnce()
      .then((c) => mounted && setState({ loading: false, data: c.data, error: null }))
      .catch((e) => mounted && setState({ loading: false, data: null, error: e }));
    return () => {
      mounted = false;
    };
  }, []);

  return state;
}
